import { prefixHost } from "../panes/utils";

export const sv: Record<string, string> = {
  // Nav labels
  "shortcut.websites": "Webbplatser",
  "shortcut.studentweb": "Studentwebben",
  "shortcut.intranet": "Intranät",

  "shortcut.studentweb.href": prefixHost("www", "/student"),
  "shortcut.intra.href": prefixHost("intra", ""),
  "shortcut.external.href": prefixHost("www", ""),
  "shortcut.missing-links.href":
    "https://www.kth.se/student/it/studenttjanster/personligamenyn/canvasrum-saknas-1.1435250",
  "shortcut.missing-links": "Läs mer om saknade Canvasrum",

  "Personal menu": "Personliga menyn",

  lang_other: "In English",
  Groups: "Grupper",
  Profile: "Profil",
  Logout: "Logga ut",
  BetaTooltip: "Ge oss feedback eller lämna betan",
  Programme: "Program",
  Schedule: "Schema",
  Services: "Tjänster",
  Studies: "Studier",
  active_courses: "Aktiva",
  all_courses: "Alla kurser",
  cstate_CANCELLED: "Nedlagd kurs",
  cstate_DEACTIVATED: "Kurs under avveckling",
  cstate_ESTABLISHED: "Inrättad kurs",
  "Om kursen (kurs-PM m.m.)": "Om kursen (kurs-PM m.m.)",
  "Canvas:": "Canvas:",
  "Alla kursrum": "Alla kursrum",
  "Administrera kurs": "Administrera kurs",
  "Hantera Omgångar/grupper": "Hantera Omgångar/grupper",
  Kursdeltagare: "Kursdeltagare",
  "Kursinformation i Kopps": "Kursinformation i Kopps",
  "Redigera introduktion till kursen": "Redigera introduktion till kursen",
  "Skapa och publicera kurs-PM": "Skapa och publicera kurs-PM",
  Kursvärdering: "Kursvärdering",
  "Se provresultat": "Se provresultat",
  "Studentgruppen / Prenumeranter": "Studentgruppen / Prenumeranter",
  "Sök tentamen": "Sök tentamen",
  hp: "hp", // Högskolepoäng
  antagna: "Antagen",
  registrerade: "Registrerad",
  omregistrerade: "Omregistrerad",
  omreg_lbl: "Omregistrerad",
  godkand: "Avklarad",
  om_kursen: "Kursinformation",
  "Search for interesting groups to follow": "Sök bland grupper att följa",
  "Profile Image": "Profilbild",
  "Help / feedback for the personal menu":
    "Hjälp och förslag kring personliga menyn",
  "Home page": "Startsida",
  "Relevant information right now. Course registration, Exam registration":
    "Aktuell information. Kursregistrering, tentaregistrering",
  "My education": "Min utbildning",
  "Overview of your studies. Programmes, courses, results on courses":
    "Studieöversikt: program, kurser och resultat",
  Examinations: "Tentor",
  "Sign up for examinations": "Anmäl dig till tentor",
  Transcripts: "Intyg",
  "Degree Certificate": "Examensbevis",
  "Apply for degree certificate": "Ta ut din examen",
  Teaching: "Undervisning",
  "KTH Webmail": "KTH Webmail",
  "News feed": "Nyheter",
  "News from your courses, groups and programmes":
    "Nyheter om kurser, grupper och program",
  "Direct notifications": "Notiser",
  "dn-new": "nya",
  "Change password": "Byt lösenord",
  "Manage KTH account": "Hantera ditt KTH-konto",
  "Wireless network": "Trådlöst nätverk (WiFi)",
  Settings: "Inställningar",
  "About me": "Om mig",
  "My Profile": "Min profil",
  "Forward KTH email": "Vidarebefordra e-post",
  "Contact details": "Kontaktuppgifter",
  "(in LADOK)": "(i LADOK)",
  "My Settings": "Mina inställningar",
  "Subscriptions, my schedule": "Prenumerationer, mitt schema",
  "Export My schedule (e.g. to your mobile phone)":
    "Exporter mitt schema (iCal)",
  "Kurs-PM": "Kurs-PM",
  "i Canvas": "i Canvas",
  VT: "VT",
  HT: "HT",
  term1: "VT",
  term2: "HT",
  Kursen: "Kursen",
  "My Programmes": "Mina program",
  Favourites: "Favoriter",
  "Find groups": "Sök bland grupper",
  "My Groups": "Mina grupper",
  // Services
  "LADOK for Students": "LADOK för studenter",
  "service_menu_change_banner": "Tjänstemenyn ändrades den 16/2-2026. För mer information om denna förändring, se artikeln",
  "service_menu_change_link_text": "Förändringar i KTH's personliga meny",
  "service_menu_change_link_url": "https://intra.kth.se/utbildning/e-larande/e-larande-nyheter/forandringar-i-kth-s-personliga-meny-1.1454398",
  // Schedule
  "schedule_banner": "Schemat har förändrats sedan den 22 juli 2026. För mer information om denna förändring, se artikeln",
  "schedule_banner_link_text": 'Nytt "Mitt Schema" i TimeEdit från 22 juli',
  "schedule_banner_link_url": "https://www.kth.se/student/nyheter/nytt-mitt-schema-i-timeedit-fran-22-juli-1.1485883",
  "schedule_banner_link_url_staff": "https://intra.kth.se/utbildning/schema-och-lokalbokning/sok-schema-1.279132",
  groups_banner_prefix:
    "Gruppwebben som samarbetsyta stängs 31 december 2026. Du som administratör behöver nu exportera gruppens innehåll och/eller radera gruppen. \n" +
    "Observera: Från och med den 1 oktober 2026 kommer delar av gruppwebben som inte längre används successivt att stänga ned, exempelvis gruppwebbar som redan har flyttats eller varit inaktiva under en längre tid. \n" +
    "Mer information hittar du i nyheten:",
  groups_banner_link_text_1: "Gruppwebben och Social stänger hösten 2026.",
  groups_banner_link_text_2: "Gruppwebben som samarbetsyta stängs hösten 2026.",
  groups_banner_text_end: " Stöd och instruktioner för hur du exporterar en gruppwebb finns i:",
  "KTH Services": "KTH-tjänster",
  "Current Courses": "Aktuella kurser",
  Other: "Övriga",
  "You don't belong to any programme.": "Du tillhör inget program.",
  "You don't belong to any groups.": "Du följer ingen grupp.",
  "You aren't studying any courses.": "Du studerar inga kurser.",
  "You aren't teaching any courses.": "Du undervisar inga kurser.",
  "Tillbaka till personliga menyn": "Tillbaka till personliga menyn",
  Examinationsrum: "Examinationsrum",
  Tillbaka: "Tillbaka",
  "Alla examinationsrum": "Alla examinationsrum",
  "No rooms found in Canvas":
    "Tillhörande rum i Canvas är ännu ej publicerat, eller saknas.",
  "No rooms found in Canvas teaching":
    "Tillhörande rum i Canvas saknas, eller så är du inte inlagd där.",
  "Program Room": "Programrum",
  prog_syllabus: "Utbildningsplan",
};
